import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';

const Login = () => {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        const response = await fetch(`${API_BASE_URL}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credentials)
        });

        const data = await response.json();

        if (data.success) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('isLoggedIn', 'true');
            navigate('/'); // Redirect to Dashboard
        } else {
            alert("Invalid Credentials");
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-4 card p-4 shadow-sm">
                    <h3 className="fw-bold mb-3">Sign In</h3>
                    <form onSubmit={handleLogin}>
                        <input type="email" placeholder="Email" className="form-control mb-2" 
                               onChange={(e) => setCredentials({...credentials, email: e.target.value})} required />
                        <input type="password" placeholder="Password" className="form-control mb-3" 
                               onChange={(e) => setCredentials({...credentials, password: e.target.value})} required />
                        <button className="btn btn-primary w-100 fw-bold">Login</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;